import React from 'react'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import { useLoadGroupEventFormValues } from 'components/group-events/create-group-event-form-wizard/hooks'
import { fullDayDateAndTime } from 'utils/dateUtils'
import { startSurvey } from 'lib/support'

const GroupEventTemplateCard = ({ event, callToAction, onCreateClick }) => {
  const loadGroupEventValues = useLoadGroupEventFormValues()
  return (
    <Card
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        <CardMedia
          image={event.featuredImageUrl}
          title={event.title}
          style={{ height: '140px' }}
        />
        <CardContent style={{ display: 'flex', flexDirection: 'column' }}>
          <Box mb={0.5}>
            <Typography variant="h6">{event.title}</Typography>
            {event.author && (
              <Typography display="block" variant="caption">
                <em>Suggested By: {event.author}</em>
              </Typography>
            )}
            {event.coachFacility && (
              <Typography display="block" variant="caption">
                {event.coachFacility.name}
              </Typography>
            )}
            {event.startDateTime && event.endDateTime && (
              <Typography variant="caption">
                {fullDayDateAndTime(event.startDateTime, event.endDateTime)}
              </Typography>
            )}
            {event.priceInCents != null && (
              <Typography display="block" variant="caption">
                ${(event.priceInCents / 100).toFixed(2)}
              </Typography>
            )}
          </Box>
          <Box mx={-0.5}>
            {event.tags.map(tag => (
              <Box key={tag} m={0.5} display="inline-block">
                <Chip size="small" label={tag} />
              </Box>
            ))}
          </Box>
        </CardContent>
      </Box>
      <CardActions>
        <Button
          color="primary"
          size="small"
          onClick={() => {
            loadGroupEventValues(event)
            onCreateClick && onCreateClick()
          }}
        >
          {callToAction}
        </Button>
      </CardActions>
    </Card>
  )
}

const SuggestEventTemplateCard = ({ onSuggestClick }) => (
  <Paper>
    <Box p={4} display="flex" flexDirection="column" justifyContent="center">
      <Box mb={0.5}>
        <Typography variant="h6">Additional Templates Coming Soon!</Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="textSecondary">
          Have a popular event you'd like to see featured? Click the button
          below to make a suggestion. Check back often as we continue to add new
          event templates.
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          startSurvey(27771605)
          onSuggestClick && onSuggestClick()
        }}
      >
        Make a suggestion
      </Button>
    </Box>
  </Paper>
)

export { SuggestEventTemplateCard }
export default GroupEventTemplateCard
